module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "counter"
  }, [_t("default"), " ", _h('span', {
    staticClass: "counter-content"
  }, [_h('span', {
    staticClass: "btn",
    on: {
      "click": increment
    }
  }, ["+"]), " ", _h('span', {
    staticClass: "input"
  }, [_s(innerNum)]), " ", _h('span', {
    staticClass: "btn",
    on: {
      "click": decrement
    }
  }, ["-"])])])
}},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/.9.7.0@vue-loader/lib/template-compiler.js?id=data-v-c4db1830!./~/.9.7.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/counter.vue
 ** module id = 13
 ** module chunks = 1
 **/